import publicApi from "./publicApi";

export const publicOrderStatusUpdate = async(order_id,status_obj) => {
    try{
        const response = await publicApi.put(`orders/public/${order_id}/status`, status_obj)
        // console.log("Response => ", response)
        return response.data
    }
    catch(error){
        throw new Error(error?.response?.data?.detail)
    }
}